export const NV05_LIST_GET_INIT = 'NV05_LIST_GET_INIT';
export const NV05_LIST_GET = 'NV05_LIST_GET';
export const NV05_LIST_GET_SUCCESS = 'NV05_LIST_GET_SUCCESS';
export const NV05_LIST_GET_FAILED = 'NV05_LIST_GET_FAILED';

export const NV05_RESET_FORM = 'NV05_RESET_FORM';
export const NV05_RESET_COMPONENT_STORE = 'NV05_RESET_COMPONENT_STORE';


export const NV05_SET_RESET_FORM_ENABLED = 'NV05_SET_RESET_FORM_ENABLED';
export const NV05_SET_COLUMN_HEADER_LIST = 'NV05_SET_COLUMN_HEADER_LIST';

export const NV05_LIST_EXPORT_TO_EXCELL = 'NV05_LIST_EXPORT_TO_EXCELL';
export const NV05_LIST_EXPORT_TO_EXCELL_FAILED = 'NV05_LIST_EXPORT_TO_EXCELL_SUCCESS';

export const SET_KEY_VALUE_PAIRS_4_NV05 = 'SET_KEY_VALUE_PAIRS_4_NV05';

export const SET_CURRENT_ROW_FOCUSED = 'SET_CURRENT_ROW_FOCUSED';

export const SET_SCROLL_TOP_POSITION = 'SET_SCROLL_TOP_POSITION';

export const SET_SELECTED_PERSON = 'SET_SELECTED_PERSON';
export const SET_LIST_FORMDATA = 'SET_LIST_FORMDATA';
export const SET_SUB_FORMDATA = 'SET_SUB_FORMDATA';



